import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Zoom } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/zoom';
import { CloseIcon } from '../../assets/icons/CloseIcon';
import { ChevronLeft } from '../../assets/icons/ChevronLeft';
import { ChevronRight } from '../../assets/icons/ChevronRight';

interface Props {
  initialIndex: number;
  onClose: () => void;
  images: string[];
}

const ImageGalleryDialog: React.FC<Props> = ({ initialIndex, onClose, images }) => {
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md" sx={{ height: '100%', width: '100%' }}>
      <DialogContent sx={{ position: 'relative', padding: 0, height: '100%', width: '100%' }}>
        <IconButton
          color="primary"
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 10,
            backgroundColor: 'rgba(255,255,255,0.8)'
          }}
        >
          <CloseIcon />
        </IconButton>

        <Swiper
          modules={[Navigation, Zoom]}
          navigation={{
            prevEl: '.custom-prev',
            nextEl: '.custom-next'
          }}
          // Pinch or double-tap to zoom - technicians use it to check the resolution of their photos on iPad
          zoom={{ maxRatio: 8 }}
          initialSlide={initialIndex}
          loop={false} // change to true to enable infinite loop
          style={{ height: '80vh' }}
          spaceBetween={10}
        >
          {images.map((src, idx) => (
            <SwiperSlide key={idx} zoom>
              <img src={src} alt={`Slide ${idx + 1}`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom navigation buttons */}
        <IconButton
          className="custom-prev"
          sx={{
            position: 'absolute',
            left: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10,
            backgroundColor: 'rgba(0,0,0,0.3)',
            color: 'white'
          }}
        >
          <ChevronLeft />
        </IconButton>

        <IconButton
          className="custom-next"
          sx={{
            position: 'absolute',
            right: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10,
            backgroundColor: 'rgba(0,0,0,0.3)',
            color: 'white'
          }}
        >
          <ChevronRight />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
};

export default ImageGalleryDialog;
